import { DateTime } from "luxon";
import {
  convertBathToStangAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";
import { existValueAndEmptyString } from "@/lib/util";

export class InvoiceDetailPresenter {
  constructor(detail) {
    const invoiceTotalPrice = formatCurrencyAndTwoDecimalsString(
      convertBathToStangAndRoundTwoDecimal(detail.invoice_total_price)
    );
    const receiptDate = detail.receipt_date
      ? DateTime.fromISO(detail.receipt_date).toUTC()
      : null;
    const receiptTotalPrice = detail.receipt_total_price 
      ? formatCurrencyAndTwoDecimalsString(
        convertBathToStangAndRoundTwoDecimal(detail.receipt_total_price)
      )
      : "-"

    const invoiceStatus = detail.invoice_status;

    return {
      invoiceNo: detail.invoice_no,
      invoiceDate: DateTime.fromISO(detail.invoice_date).toUTC(),
      invoiceTotalPrice: invoiceTotalPrice,
      invoiceDocumentUrl: detail.invoice_document_url,
      providerName: detail.provider_name,
      receiptNo: detail.receipt_no || "-",
      receiptDate: receiptDate,
      receiptTotalPrice: receiptTotalPrice,
      rejectedMessage: detail.invoice_rejected_message,
      rejectedNote: detail.invoice_rejected_note,
      adminName: existValueAndEmptyString(detail.invoice_status_by_admin)
        ? detail.invoice_status_by_admin : "-",
      status: invoiceStatus
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/other-web/supplier/presenters/InvoiceDetailPresenter.js